import { DocumentDuplicateIcon } from "@heroicons/react/outline";
import firebase from "firebase/app";
import { useTranslation } from "next-i18next";
import { useState } from "react";

import { AnalyticsEventEnum } from "@/consts/AnalyticsEventEnum";
import { CopyIcon } from "@/features/common/components/icons/CopyIcon";

export const CopyToClipboard = ({
  target,
  svgClassName = "",
  logEventSource,
}: {
  target: string;
  svgClassName?: string;
  logEventSource?: "nft-detail" | "nft-account";
}) => {
  const { t } = useTranslation("common");
  const [showCopied, setShowCopied] = useState(false);

  const copyToClipboard = () => {
    firebase.analytics().logEvent(AnalyticsEventEnum.CopyToClipBoard, {
      target,
      source: logEventSource,
    });
    navigator.clipboard.writeText(target).then(
      function () {
        if (showCopied) return;
        setShowCopied(true);
        setTimeout(() => setShowCopied(false), 2000);
      },
      function () {},
    );
  };

  return (
    <div
      className="tooltip flex items-center cursor-pointer"
      onClick={copyToClipboard}
    >
      <DocumentDuplicateIcon width={16} height={16} className={svgClassName} />
      <span className="tooltiptext tooltip-tr after:block">
        {showCopied ? t("common:copied") : t("common:copy")}
      </span>
    </div>
  );
};
